import { HubConnectionBuilder, HttpTransportType } from '@microsoft/signalr';
import { ROLE } from '@/constants/role.constant';
import store from '@/stores/store';
class WebSocket {
  _connection = null;
  /**
   * kh?i t?o connect
   * @param {any} token
   */
  async init(token) {
    if (!this._connection) {
      this._connection = new HubConnectionBuilder()
        .withUrl(window._socketUrl, {
          withCredentials: true,
          transport: HttpTransportType.LongPolling,
        })
        .withAutomaticReconnect()
        .build();

      await this.startConnect();
    }
  }

  /**
   * connect
   */
  async startConnect() {
    if (this._connection.state != 'Connected') {
      await this._connection
        .start()
        .then(() => {
          console.log('SignalR connected');
          this._connection.on(
            'SendMessageNotificationChangeRequest',
            async (user, message) => {
              console.log(`SendMessageNotificationChangeRequest: ${message} `);
              try {
                store.commit('refresh/REFRESH');
              } catch (ex) {
                console.log(ex);
              }
            }
          );
        })
        .catch((err) =>
          console.error('Error while starting connection: ' + err)
        );
      this._connection.on('Ping', () => {
        connection.invoke('Pong');
      });
    }
  }

  async listenEvent(event) {
    this._connection.on(event, async (user, message) => {
      try {
        store.commit('refresh/REFRESH');
      } catch (ex) {
        console.log(ex);
      }
    });
  }

  sendMessage(user, message) {
    if (this._connection) {
      this._connection.send('SendMessage', user, message);
    }
  }

  sendMessageToMultipleGroups(user, message) {
    if (this._connection) {
      this._connection.send(
        'SendMessageNotificationChangeRequest',
        user,
        message
      );
    }
  }

  async stop() {
    if (this._connection && this._connection.state == 'Connected') {
      await this._connection.stop();
    }
  }

  async sendGroups(groupNames, message) {
    try {
      for (const groupName of groupNames) {
        await this._connection.invoke(
          'SendMessageToMultipleGroups',
          groupName,
          message
        );
        console.log(`Joined group: ${groupName}`);
      }
    } catch (err) {
      console.error('Error joining group: ', err);
    }
  }

  async joinGroups(groupNames) {
    try {
      for (const groupName of groupNames) {
        await this._connection.invoke('JoinGroups', groupName);
        console.log(`Joined group: ${groupName}`);
      }
    } catch (err) {
      console.error('Error leaving groups:', err);
    }
  }

  async leaveGroups(groupNames) {
    try {
      for (const groupName of groupNames) {
        await this._connection.invoke('LeaveGroups', groupName);
        console.log('User has left the groups:', groupName);
      }
    } catch (err) {
      console.error('Error leaving groups:', err);
    }
  }
}

let webSocket = new WebSocket();
export default webSocket;
